export default "﻿<div style=\"\" class=\"calendar\">\n    \n</div>"